import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RapportiComponent } from './rapporti.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [RapportiComponent],
  exports:[RapportiComponent]
})
export class RapportiModule { }
